import { formatRelativeDate } from "../../../Common/serverTimestamp";

export const PAYMENT_TERMS_NOT_SET_LABEL = "Not set";

/** Match AddVendors / EditVendors: store up to 10 digits only */
export function normalizePhoneDigits(value) {
  return String(value ?? "").replace(/\D/g, "").slice(0, 10);
}

function isBlankVendorTimestamp(value) {
  if (value == null) return true;
  const s = String(value).trim();
  if (s === "" || s.toLowerCase() === "null") return true;
  if (s.startsWith("0000-00-00")) return true;
  return false;
}

/**
 * For relative "last changed" labels: use updated_* from API when set;
 * if null/blank/unset, fall back to created_*.
 */
export function pickVendorListTimestampForDisplay(item) {
  const raw = item ?? {};
  const updated =
    raw.updated_timestamp  ?? raw.updated_at;
  if (!isBlankVendorTimestamp(updated)) return updated;
  return (
    raw.created_on ??
    raw.created_at ??
    null
  );
}

/** Map Vendor_api_new/vendor_list rows to local vendor row shape */
export function mapVendorApiItemToRow(item, index) {
  const idRaw = item?.vendor_id ?? item?.vendorId ?? item?.id;
  const id =
    idRaw != null && String(idRaw).trim() !== ""
      ? String(idRaw)
      : `v-row-${index}`;
  const name =
    (item?.name ?? item?.vendor_name ?? "").trim() || "";
  const contact = (item?.contact_name ?? item?.contact ?? "").trim();
  const email = (item?.email ?? "").trim();
  const phone = normalizePhoneDigits(
    item?.phone ?? item?.phone_number ?? item?.mobile ?? ""
  );
  const termsRaw = item?.payment_terms ?? item?.payment_term ?? item?.terms;
  const terms =
    termsRaw != null &&
    String(termsRaw).trim() !== "" &&
    String(termsRaw).trim().toLowerCase() !== "null"
      ? String(termsRaw).trim()
      : PAYMENT_TERMS_NOT_SET_LABEL;
  const paymentTermsApiNull =
    item?.payment_terms == null ||
    String(item?.payment_terms ?? "").trim() === "";
  const productsRaw =
    item?.products ??
    item?.product_count ??
    item?.products_count ??
    item?.total_products ??
    0;
  const products = Number(productsRaw) || 0;
  const preferred = Boolean(item?.preferred ?? item?.is_preferred ?? false);
  const updated =
    formatRelativeDate(pickVendorListTimestampForDisplay(item)) || "—";

  return {
    id,
    name,
    contact,
    email,
    phone,
    terms,
    paymentTermsApiNull,
    products,
    preferred,
    updated,
    raw: item,
  };
}
